import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/cookieConsentApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import TopBannerTemplateWidget from "../../../../components/Apps/CookieConsent/Template/TopBannerWidget";
import RightFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/RightFloatingBoxWidget";
import CenterFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/CenterFloatingBoxWidget";
import LeftFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/LeftFloatingBoxWidget";
import BottomBannerTemplateWidget from "../../../../components/Apps/CookieConsent/Template/BottomBannerWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/CookieConsent/ContentTab";
import LayoutTab from "../../../../components/Apps/CookieConsent/LayoutTab";
import StyleTab from "../../../../components/Apps/CookieConsent/StyleTab";

export default function EditCookieConsent() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Cookie Consent");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);
    
    const [cookieConsentTabData, setCookieConsentTabData] = useState({
        is_website_frontend: "",  
        compliance_type: "Hide_Allow_Cookies",  
        language_type: "English",  
        message: "We use cookie to improve your experience on our site. By using our site you consent cookies.",  
        policy_display_type: "Show_Policy_link",       
        policy_url: "https://upgadeify.com",       
        policy_link_text: "Learn more",       
        allow_button_text: "Allow Cookies",       
        decline_button_text: "Decline",       
        postion_type: "top-banner-layout",       
        is_show_cookie_icon: 1,       
        is_show_confirmation_button: 1,    
        confirmation_button_text: "OK",   
        background_color: "",       
        text_color: "",       
        link_color: "",       
        allow_button_color: "",       
        decline_button_color: "",       
        confirmation_button_background_color: "",       
        text_font_size: "",       
        style_custom_css: "",       
        style_custom_js: "",       
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
    ];

    // Function to update values dynamically
    const updateCookieConsentTabData = (key, value) => {
        setCookieConsentTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setCookieConsentTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setCookieConsentTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(cookieConsentTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/cookie-consent');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };
 
  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/cookie-consent/icons/${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                            <ContentTab updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData} />
                        )}
                        {activeSection === "Layout" && (
                            <LayoutTab updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData} />
                        )}
                        {activeSection === "Style" && (
                            <StyleTab updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                        )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/cookie-consent"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/cookie-consent.svg`} alt="cookie-consent"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/cookie-consent/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/cookie-consent" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Countdown Timer <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                   {/*Check template type*/}
                   {activeTemplateSection === "Top_Banner_Temp" && (
                      <TopBannerTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Right_Floating_Box_Temp" && (
                      <RightFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Center_Floating_Box_Temp" && (
                      <CenterFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Left_Floating_Box_Temp" && (
                      <LeftFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Bottom_Banner_Temp" && (
                      <BottomBannerTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 